export const makeid = (length = 20) => {
  let result = '';
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-';
  const charactersLength = characters.length;
  let counter = 0;
  while (counter < length) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
    counter += 1;
  }
  return result;
}
export const makeClientId = (site_id) => {
  const cid = getClientId()
  if (!cid) localStorage.setItem(`_client_id`, `${site_id}-${makeid(200)}`)
}
export const getClientId = () => {
  return localStorage.getItem(`_client_id`)
}
